module.exports = __webpack_public_path__ + "img/refresh.13e1a5c3.svg";